import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { media } from '../../helpers';

const ReviewModalContainer = styled(motion.div)`
    .overlay-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgb(34, 34, 34, 0.75);
        z-index: 5000;
        display: flex;
        align-items: center;
        justify-content: center;

        .close-btn {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: 5500;
            background-color: transparent;

            &:focus,
            &:active {
                outline: 0;
            }
        }

        .modal-content-container {
            background-color: #fff;
            flex: 1;
            max-width: 90vw;
            padding: 40px;
            border-radius: 5px;
            position: relative;
            z-index: 6000;
            max-height: 70vh;
            overflow-y: scroll;
            ${media.medium`max-width: 650px; max-height: 100%; overflow-y: visible;`}

            .form-container {
                form {
                    margin-bottom: 0px;
                    .input-container {
                        display: flex;
                        flex-wrap: wrap;
                        margin-bottom: 20px;
                        &:last-child {
                            margin-bottom: 0px;
                        }

                        > * {
                            flex: 1 1 100%;
                        }

                        .mini-label {
                            display: block;
                        }

                        label {
                            margin-bottom: 5px;
                        }

                        input {
                            border: 1px solid #ccc;
                            padding-left: 10px;
                            height: 39px;
                        }

                        textarea {
                            border: 1px solid #ccc;
                            padding-left: 10px;
                            padding-top: 10px;
                            min-height: 130px;
                        }

                        button {
                            background-color: #f74c34;
                            color: #fff;
                            max-width: 120px;
                            padding: 7px 0;
                            border-radius: 5px;
                            border: 1px solid #f74c34;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }

    .stars {
        .radio-stars {
            display: inline-block;
            position: relative;

            unicode-bidi: bidi-override;
            direction: rtl;

            counter-reset: star-rating;
            line-height: 1;
            font-size: 0;

            .radio-star::before {
                content: '☆';
            }

            .radio-star:hover {
                &::before,
                ~ .radio-star::before {
                    content: '★';
                }
            }
        }

        .radio-star {
            display: inline-block;
            overflow: hidden;
            cursor: pointer;

            padding: 5px 2px;
            width: 1em;

            direction: ltr;
            color: rgba(0, 0, 0, 0.25);
            font-size: 25px;
            white-space: nowrap;

            &::before {
                content: '☆';
            }

            &.active {
                color: #f74c34;
                &::before {
                    content: '★';
                }
            }

            &:hover ~ &,
            input:checked ~ & {
                color: #000;
            }

            input:checked ~ & {
                counter-increment: star-rating;

                &::before {
                    content: '★';
                }
            }
        }

        .radio-star-total {
            pointer-events: none;
            direction: ltr;
            unicode-bidi: bidi-override;

            position: absolute;
            right: -2em;
            bottom: 0.5em;

            color: gray;
            color: white;
            font-size: 25px / 2;

            &::before {
                content: counter(star-rating) '/5';
            }
        }

        .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            margin: -1px;
            padding: 0;
            clip: rect(0, 0, 0, 0);
            border: 0;
        }
    }
`;

const ReviewModal = ({ setIsModalShowing, handle }) => {
    const [stars, setStars] = useState(5);
    const [isReviewComplete, setIsReviewComplete] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    function handleReviewSubmit(e) {
        const newReview = {
            sku: '30549327376',
            name: 'Sam Davidoff',
            review:
                'Lorem ipsum dolor sit amet consectetur adipisicing elit.Quasi officiis molestias laborum pariatur minima odio ipsa fugit, commodi rerum, magni eaque officia velit et, quis cupiditate fuga reiciendis obcaecati tempore!',
            rating: 5,
        };

        e.preventDefault();
        const scriptURL = 'https://api.reviews.io/product/review/new';
        fetch(scriptURL, {
            method: 'POST',
            headers: {
                store: 'knotty-tie',
                apiKey: '363744e00915183bbcd5afaf50f38795',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newReview),
        })
            .then((response) => {
                console.log('Success!', response);
                setIsReviewComplete(true);
                setTimeout(function () {
                    setIsModalShowing(false);
                }, 5000);
            })
            .catch((error) => console.error('Error!', error.message));
        setIsButtonDisabled(true);

        if (!isButtonDisabled) {
        }
    }

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;

    useEffect(() => {
        console.log('reviews');
        fetch(
            'https://api.reviews.io/product/review?store=knotty-tie&sku=30549327376&per_page=100'
        ).then((res) =>
            res.json().then((res) => {
                console.log(res);
            })
        );
    }, []);

    return (
        <ReviewModalContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
            }}
            // transition={{
            //     duration: 0.8,
            //     ease: [0.04, 0.62, 0.23, 0.98],
            // }}
        >
            <div className="overlay-bg">
                <button
                    onClick={() => setIsModalShowing(false)}
                    className="close-btn"
                ></button>
                <div className="modal-content-container">
                    <div className="inner-wrap">
                        <h4>New Review</h4>

                        {isReviewComplete && (
                            <div className="confirmation-container">
                                <h4>Thanks for submitting your review!</h4>
                            </div>
                        )}
                        {!isReviewComplete && (
                            <div className="form-container">
                                <form onSubmit={(e) => handleReviewSubmit(e)}>
                                    <div className="input-container">
                                        <input
                                            name="product_handle"
                                            type="text"
                                            value={handle}
                                            className="hidden"
                                        />
                                        <input
                                            name="date"
                                            type="text"
                                            value={today}
                                            className="hidden"
                                        />
                                        <div className="input-container">
                                            <label
                                                class="stars"
                                                htmlFor="stars"
                                            >
                                                <span className="mini-label">
                                                    Stars
                                                </span>
                                                <input
                                                    className="hidden"
                                                    type="text"
                                                    name="stars"
                                                    value={stars}
                                                />
                                                <div class="radio-stars">
                                                    <input
                                                        class="sr-only"
                                                        id="radio-5"
                                                        name="radio-stars"
                                                        type="radio"
                                                        value="5"
                                                    />
                                                    <label
                                                        className={
                                                            'radio-star ' +
                                                            (stars > 0 &&
                                                            stars > 4
                                                                ? 'active'
                                                                : '')
                                                        }
                                                        for="radio-5"
                                                        onClick={() =>
                                                            setStars(5)
                                                        }
                                                    >
                                                        5
                                                    </label>
                                                    <input
                                                        checked=""
                                                        class="sr-only"
                                                        id="radio-4"
                                                        name="radio-star"
                                                        type="radio"
                                                        value="4"
                                                    />
                                                    <label
                                                        className={
                                                            'radio-star ' +
                                                            (stars > 0 &&
                                                            stars > 3
                                                                ? 'active'
                                                                : '')
                                                        }
                                                        for="radio-4"
                                                        onClick={() =>
                                                            setStars(4)
                                                        }
                                                    >
                                                        4
                                                    </label>
                                                    <input
                                                        class="sr-only"
                                                        id="radio-3"
                                                        name="radio-star"
                                                        type="radio"
                                                        value="3"
                                                    />
                                                    <label
                                                        className={
                                                            'radio-star ' +
                                                            (stars > 0 &&
                                                            stars > 2
                                                                ? 'active'
                                                                : '')
                                                        }
                                                        for="radio-3"
                                                        onClick={() =>
                                                            setStars(3)
                                                        }
                                                    >
                                                        3
                                                    </label>
                                                    <input
                                                        class="sr-only"
                                                        id="radio-2"
                                                        name="radio-star"
                                                        type="radio"
                                                        value="2"
                                                    />
                                                    <label
                                                        className={
                                                            'radio-star ' +
                                                            (stars > 0 &&
                                                            stars > 1
                                                                ? 'active'
                                                                : '')
                                                        }
                                                        for="radio-2"
                                                        onClick={() =>
                                                            setStars(2)
                                                        }
                                                    >
                                                        2
                                                    </label>
                                                    <input
                                                        class="sr-only"
                                                        id="radio-1"
                                                        name="radio-star"
                                                        type="radio"
                                                        value="1"
                                                    />
                                                    <label
                                                        className={
                                                            'radio-star ' +
                                                            (stars > 0 &&
                                                            stars > 0
                                                                ? 'active'
                                                                : '')
                                                        }
                                                        for="radio-1"
                                                        onClick={() =>
                                                            setStars(1)
                                                        }
                                                    >
                                                        1
                                                    </label>
                                                </div>
                                            </label>
                                        </div>
                                        <div className="input-container">
                                            <label htmlFor="reviewer_name">
                                                Name (This will be public)
                                            </label>
                                            <input
                                                type="text"
                                                name="reviewer_name"
                                                required
                                            />
                                        </div>
                                        <div className="input-container">
                                            <label htmlFor="email">Email</label>
                                            <input
                                                type="email"
                                                required
                                                name="email"
                                            />
                                        </div>
                                        <div className="input-container">
                                            <label htmlFor="review_title">
                                                Review Title
                                            </label>
                                            <input
                                                type="text"
                                                required
                                                name="review_title"
                                            />
                                        </div>
                                        <div className="input-container">
                                            <label htmlFor="review_body">
                                                Review Body
                                            </label>
                                            <textarea
                                                required
                                                name="review_body"
                                            />
                                        </div>
                                        <div className="input-container">
                                            <button>Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ReviewModalContainer>
    );
};

export default ReviewModal;
